import dayjs from "apps/visits/packages/shared/libs/dayjs";
import { DATE_FORMAT } from "../config/date-time";

export const formatDate = (date: string | Date) => {
  return dayjs(date).format(DATE_FORMAT);
};
